//
//
//
//
//
//
//
//
//
//
//

import CustomerService from '@/api/customer.service';
import { Loading } from 'quasar';

export default {
    data() {
        return { iframeUrl: null, relogins: [] };
    },

    async mounted() {
        window.addEventListener('message', this.onSelbstauskunftMessage);
        await this.login();
    },

    beforeUnmount() {
        window.removeEventListener('message', this.onSelbstauskunftMessage);
    },

    methods: {
        async login() {
            Loading.show();
            try {
                const { data } = await CustomerService.getLoginForSelbstauskunft();
                this.iframeUrl = data.href;
            } catch (error) {
                this.$handleError(error);
                Loading.hide();
            }
        },

        onIframeLoad() {
            Loading.hide();
        },

        // The embedded Selbstauskunft reports an ended session (expired, logged
        // out, revoked). While the portal session is alive, mint a fresh token
        // and reload the iframe. Rate-limited per minute, not per page lifetime:
        // a long-lived tab renews many times, a misconfigured instance must not loop.
        onSelbstauskunftMessage(event) {
            if (!this.iframeUrl || event.origin !== new URL(this.iframeUrl).origin) {
                return;
            }
            if (event.data?.source !== 'selbstauskunft' || event.data.event !== 'session-ended') {
                return;
            }
            const now = Date.now();
            this.relogins = this.relogins.filter(at => now - at < 60000);
            if (this.relogins.length >= 3) {
                return;
            }
            this.relogins.push(now);
            this.login();
        },
    },
};
